define("shared/components/shared/credentials/password-input", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _tracking, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/object",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper--lg u--relative">
    <label>{{t "shared_words.password"}}</label>
    <Input
      @class={{concat "tSU--card__input form-control o--form__input qa--" @qaClassName}}
      data-test-id={{@dataTestID}}
      @autocomplete="new-password"
      @placeholder={{t "authorization.create_account.placeholder_password"}}
      @type={{this.passwordInputType}}
      @value={{@password}}
    />
    {{#if this.showPasswordInput}}
      <button type="button" class="o--btn--lg tSU--card__inputButton" {{on "click" this.togglePasswordVisibility}}>
        {{svg-jar "view" class="o--icon--md tSU--card__inputIcon"}}
      </button>
    {{else}}
      <button type="button" class="o--btn--lg tSU--card__inputButton" {{on "click" this.togglePasswordVisibility}}>
        {{svg-jar "hide" class="o--icon--md tSU--card__inputIcon"}}
      </button>
    {{/if}}
  </div>
  */
  {
    "id": "GF1g+kUJ",
    "block": "[[[10,0],[14,0,\"o--formWrapper--lg u--relative\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"shared_words.password\"],null]],[13],[1,\"\\n  \"],[8,[39,1],[[16,\"data-test-id\",[30,1]]],[[\"@class\",\"@autocomplete\",\"@placeholder\",\"@type\",\"@value\"],[[28,[37,2],[\"tSU--card__input form-control o--form__input qa--\",[30,2]],null],\"new-password\",[28,[37,0],[\"authorization.create_account.placeholder_password\"],null],[30,0,[\"passwordInputType\"]],[30,3]]],null],[1,\"\\n\"],[41,[30,0,[\"showPasswordInput\"]],[[[1,\"    \"],[11,\"button\"],[24,0,\"o--btn--lg tSU--card__inputButton\"],[24,4,\"button\"],[4,[38,4],[\"click\",[30,0,[\"togglePasswordVisibility\"]]],null],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"view\"],[[\"class\"],[\"o--icon--md tSU--card__inputIcon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[11,\"button\"],[24,0,\"o--btn--lg tSU--card__inputButton\"],[24,4,\"button\"],[4,[38,4],[\"click\",[30,0,[\"togglePasswordVisibility\"]]],null],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"hide\"],[[\"class\"],[\"o--icon--md tSU--card__inputIcon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"@dataTestID\",\"@qaClassName\",\"@password\"],false,[\"t\",\"input\",\"concat\",\"if\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/credentials/password-input.hbs",
    "isStrictMode": false
  });

  let PasswordInputComponent = (_class = class PasswordInputComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "showPasswordInput", _descriptor, this);
    }

    get passwordInputType() {
      return this.showPasswordInput ? 'text' : 'password';
    }

    togglePasswordVisibility() {
      this.showPasswordInput = !this.showPasswordInput;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "showPasswordInput", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "togglePasswordVisibility", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePasswordVisibility"), _class.prototype)), _class);
  _exports.default = PasswordInputComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PasswordInputComponent);
});